var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AddToCart',{attrs:{"preset":_vm.preset},on:{"close":function($event){return _vm.$emit('close')},"added":function($event){return _vm.$emit('added')}}})}
var staticRenderFns = []

export { render, staticRenderFns }